module.exports = __webpack_public_path__ + "static/media/general-de-seguros-vial.7a4da6b6.svg";